import Colors from "assets/Colors";
import DashboardIcon from "components/icons/DashboardIcon";
import MapIcon from "components/icons/Map";
import ItemIcon from "components/icons/ItemIcon";
import FileIcon from "components/icons/FileIcon";
import ClientsIcon from "components/icons/ClientsIcon";
import WorkerIcon from "components/icons/WorkerIcon";
import ConfigurationIcon from "components/icons/ConfigurationIcon";
import { Layout } from "antd";
import LanguageSelector from "containers/SideBarTopMenuHOC/LanguageSelector";
import { useLocation } from "react-router-dom";
import Cash_management from "components/icons/Cash_managementIcon";
import { useTranslation } from "react-i18next";
import s from "./styles";
import Profile from "../Profile";
import StoreSelector from "../StoreSelector";
import SideBarItem from "./SideBarItem";

const { Sider } = Layout;

function CustomSider({ showingSecondarySider, openSideBar, setOpenSideBar }) {
  const { t } = useTranslation();
  const location = useLocation();
  const path = location.pathname;
  return (
    <Sider
      breakpoint="xl"
      collapsedWidth="0"
      onBreakpoint={() => {}}
      onCollapse={() => {}}
      width={183}
      style={{
        background: Colors.BG_MENU,
        paddingTop: "40px",
        boxShadow: "6px 0px 18px rgba(0, 0, 0, 0.06)",
        position: showingSecondarySider ? "absolute" : "",
        zIndex: 2,
      }}
      zeroWidthTriggerStyle={{ top: "0" }}
      trigger={<div />}
      collapsed={showingSecondarySider ? openSideBar : undefined}
    >
      <s.ProfileWrapperSideBar>
        <Profile />
      </s.ProfileWrapperSideBar>
      <s.ProfileWrapperSideBar>
        <LanguageSelector />
      </s.ProfileWrapperSideBar>
      <s.ProfileWrapperSideBar>
        <StoreSelector />
      </s.ProfileWrapperSideBar>

      <SideBarItem
        selected={path.includes("/dashboard")}
        Icon={DashboardIcon}
        text={t("containers.SideBarTopMenuHOC.Sider.dashboard")}
        path="/dashboard"
      />
      <SideBarItem
        selected={path.includes("/inventory/")}
        Icon={ItemIcon}
        text={t("containers.SideBarTopMenuHOC.Sider.inventory")}
        path="/inventory/items"
        setOpenSideBar={setOpenSideBar}
      />
      <SideBarItem
        selected={path.includes("/reports/")}
        Icon={FileIcon}
        text={t("containers.SideBarTopMenuHOC.Sider.inform")}
        path="/reports/sales"
        setOpenSideBar={setOpenSideBar}
      />
      <SideBarItem
        selected={path.includes("/customer/")}
        Icon={ClientsIcon}
        text={t("containers.SideBarTopMenuHOC.Sider.clients")}
        path="/customer/list"
      />
      <SideBarItem
        selected={path.includes("/employees/")}
        Icon={WorkerIcon}
        text={t("containers.SideBarTopMenuHOC.Sider.workers")}
        path="/employees/list"
        setOpenSideBar={setOpenSideBar}
      />
      <SideBarItem
        selected={path.includes("/rooms")}
        style={{ marginBottom: "22px" }}
        Icon={MapIcon}
        text={t("containers.SideBarTopMenuHOC.Sider.Rooms")}
        path="/rooms"
      />
      <s.Separator />
      <SideBarItem
        selected={path.includes("/operations/")}
        style={{ marginTop: "23px" }}
        Icon={Cash_management}
        text={t("containers.SideBarTopMenuHOC.Sider.cashManagement")}
        path="/operations/sales"
        setOpenSideBar={setOpenSideBar}
      />
      {/* <SideBarItem
        selected={path.includes("/reservations/")}
        style={{ marginTop: "23px" }}
        Icon={Cash_management}
        text={t("containers.SideBarTopMenuHOC.Sider.reservationModules")}
        path={"/reservations/"}
        setOpenSideBar={setOpenSideBar}
      /> */}
      <SideBarItem
        selected={path.includes("/settings/")}
        Icon={ConfigurationIcon}
        text={t("containers.SideBarTopMenuHOC.Sider.configuration")}
        path="/settings/general"
        setOpenSideBar={setOpenSideBar}
      />
      {/* <SideBarItem
        Icon={IntegrationsIcon}
        text={t('containers.SideBarTopMenuHOC.Sider.integrations')}
      /> */}
    </Sider>
  );
}

export default CustomSider;
